export const status = {
  WAITING: 'WAITING',
  EXPIRED: 'EXPIRED',
  PRINTED: 'PRINTED',
  FILLED: 'FILLED',
  BILLED: 'BILLED',
  CANCELLED: 'CANCELLED',
  LOST: 'LOST',
  ALL: 'ALL',
}

export const statusText = {
  WAITING: 'รอเบิก',
  EXPIRED: 'หมดอายุ',
  PRINTED: 'พิมพ์ใบเบิกแล้ว',
  FILLED: 'เติมแล้ว',
  BILLED: 'ได้รับบิลแล้ว',
  CANCELLED: 'ยกเลิก',
  LOST: 'สูญหาย',
  ALL: 'ทั้งหมด',
  CANBEUSED: 'เติมน้ำมันได้',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const specialReason = {
  TRAVEL: { value: 'TRAVEL', label: 'น้ำมันเดินทาง' },
  RETURN: { value: 'RETURN', label: 'น้ำมันกลับบริษัท' },
  ONE_YARD_CONTAINER: { value: 'ONE_YARD_CONTAINER', label: '1 ตู้จากลาน' },
  TWO_YARD_CONTAINERS: { value: 'TWO_YARD_CONTAINERS', label: '2 ตู้จากลาน' },
  OTHER: { value: 'OTHER', label: 'อื่น ๆ' },
}
